import React, { useEffect, useState } from 'react';
import '../Dashboard.css';
import { IoSearch } from 'react-icons/io5';

const baseURL = process.env.BASE_URL || "";

function Dash() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const adminId = localStorage.getItem('adminId'); // from login

  useEffect(() => {
    const fetchHospitalData = async () => {
      try {
        const res = await fetch(`${baseURL}/api/adminroutes/visitors/hospital`);
        const response = await res.json();

        // Add date to each visitor (it's sent from backend)
        setData(response);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    if (adminId) {
      fetchHospitalData();
    }
  }, [adminId]);

  const filteredData = data.filter((user) =>
    user?.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const groupByDate = (users) =>
    users?.reduce((acc, user) => {
      if (!acc[user.date]) acc[user.date] = [];
      acc[user.date].push(user);
      return acc;
    }, {});

  const groupedData = groupByDate(filteredData);
  

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      // Optional: Add debounce or search call
    }
  };

  console.log(groupedData);
  

  return (
    <div className='dashboard-page'>
    <div className="app">
      <h1>HOSPITAL USERS</h1>

      <div className="search-bar">
        <input
          type="text"
          className="search-input"
          placeholder="Search by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button className="search-button">
          <IoSearch />
        </button>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : filteredData.length === 0 ? (
        <p>No users found.</p>
      ) : (
        Object.entries(groupedData).map(([date, users]) => (
          <div key={date} className="table-wrapper">
            <h2 className="date-header">📅 Date: {date}</h2>
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Age</th>
                  <th>Gender</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Blood Group</th>
                  <th>Guardian Name</th>
                  <th>Guardian Phone</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{user.name}</td>
                    <td>{user.age}</td>
                    <td>{user.gender}</td>
                    <td>{user.phoneNumber}</td>
                    <td>{user.email}</td>
                    <td>{user.bloodGroup}</td>
                    <td>{user.guardianName}</td>
                    <td>{user.guardianNumber}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))
      )}
    </div>
    </div>
  );
}

export default Dash;
